import React, { Component } from 'react';
import { CardBody, Label, Form, FormGroup, Row, Col, DropdownItem, Button, Input, DropdownToggle, DropdownMenu, ButtonDropdown } from 'reactstrap'
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Modal from '../../../../components/UI/Modal/Modal';
import TableView from '../../Table/index';
import { CORPORATE_LABEL } from '../../constants';
import { DEFAULT_CASE_TYPE_LIST } from '../constants';
import { setSearchCorporateParameter, searchCorporateResultsSuccess } from '../../Create/actions'
import { Preloading as preloading } from '../../../../components/UI/Preloader/action';
import { BULK_CASE, BULK_QUICK_CASE } from './constant';
class BulkCaseForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            body: null,
            submitted: false,
            select: '',
            isUser: false,
            searchSelected: null,
            inputField: "",
            dropdownOpen: false,
            search: '',
            caseType: 'Bulk Case',
            isBulkCase: false
        }
        this.data = [];
        this.newProp = "";
        this.newProduct = "";
        this.status = "";
        this.error = "";
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
    }
    handleModal = () => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal
        }))
    }
    componentDidMount() {
        this.setState(
            {
                caseType: "Bulk Case"
            },
            () => {
                this.props.change('caseType', "Bulk Case");
            }
        );
    }    
    componentDidUpdate(prevProps) {
        if (this.props.updateFlag !== prevProps.updateFlag) {
            if (this.props.updateFlag) {
                this.props.reset()
            }
        }
    }
    handleCorporateSearchClick = () => {
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
        this.setState({
            submitted: false,
            select: "Name",
            isUser: false,
            searchSelected: "Corporate"
        });
        this.searchCriteriaDataItems = ["Name", "GST", "City"];
        this.searchPlaceholder = "Search Name";
        this.searchCriteriaDataItems.map((item, index) => {
            return (this.searchCriteriaItems.push(<DropdownItem className='search-dropdown-item' onClick={this.onhandleSelected} value={item} key={index}>{item}</DropdownItem>))
        });
        this.setState({
            body: <div>
                <hr />
                <TableView selected={CORPORATE_LABEL} />
                <Button color="primary" className="mr-1 mt-3" onClick={this.selectCorporatre}>Done</Button>
                <Button color="secondary" className="mr-1 mt-3" onClick={this.handleModal}>Cancel</Button>
            </div>,
            inputField: "corporateSearch"
        })
        this.handleModal()
    }
    selectCorporatre = () => {
        this.props.preloading(true);
        setTimeout(() => {
            this.props.preloading(false)
        }, 1000)
        this.props.selectedCorporateCallback(this.props.selectedCorp);
        this.props.change('corporate', this.props.selectedCorp.corporateName);
        this.props.corporateResults([])
        this.handleModal()
    }
    toggle = () => {
        this.setState((prevState) => ({
            dropdownOpen: !prevState.dropdownOpen
        }))
    }
    onhandleSelected = (event) => {
        this.setState({
            select: event.target.value
        });
        this.searchPlaceholder = "Search " + event.target.value;
    }
    search = () => {
        if (this.state.searchSelected === CORPORATE_LABEL) {
            this.props.setSearchCorporateParameter(
                this.state.select,
                this.state.search);
        }
    }
    handleInputChange = (event) => {
        this.setState({
            search: event.target.value
        })
    }

    handleOnCaseTypeChange = (propertyName, event) => {
        const newCaseType = event.target.value;
    
        this.setState(
            {
                caseType: newCaseType,
                isBulkCase: newCaseType === BULK_CASE
            },
            () => {
                this.props.onCaseTypeChange(newCaseType);
            }
        );
    }    

    render() {
        let dropdown
        let search
        let corporateSelector

        if (this.state.submitted === false) {
            dropdown = this.state.isUser ? "" : <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle caret>
                    {this.state.select}
                </DropdownToggle>
                <DropdownMenu className='search-type-dropdown'>
                    {this.searchCriteriaItems}
                </DropdownMenu>
            </ButtonDropdown>;
            search = <div className='d-flex'>
                {dropdown}
                <Input type="text" name={this.state.inputField} value={this.state.search} className="ml-4" id="corporate_search" placeholder={this.searchPlaceholder} onChange={this.handleInputChange} />
                <Button color="primary" className="ml-4" disabled={this.state.disabled} onClick={this.search}>
                    <i className="fa fa-search fa-fw"></i> Search
                </Button>
            </div>
        }
        if (this.state.caseType != BULK_CASE) {
            corporateSelector = <Field
                name="corporate"
                className="form-control"
                type="text"
                validate={[required]}
                component={renderField}
                label="Corporate"
                placeholder="Search and Select a Corporate"
                onclick={this.handleCorporateSearchClick} />
        }
        return (
            <CardBody className=''>
                <Form className="w-100" onChange={this.handleFormChange} autoComplete="on">
                    <label>Case Type <i className='text-danger'>*</i></label>
                    <Field
                        name="caseType"
                        className="form-control"
                        type="dropdown"
                        validate={[required]}
                        component="select"
                        label="Case Type"
                        onChange={(e) => this.handleOnCaseTypeChange('caseType', e)}
                        placeholder="Choose a Case Type">
                        {
                            DEFAULT_CASE_TYPE_LIST.map(casetype => {
                               return <option key={casetype}>{casetype}</option>
                            })
                        }
                    </Field>

                    {(this.state.isBulkCase) ?    <Field
                        name="corporate"
                        className="form-control"
                        type="text"
                        validate={[required]}
                        component={renderField}
                        label="Corporate"
                        // hidden={this.state.caseType === BULK_QUICK_CASE}
                        placeholder="Search and Select a Corporate"
                        onclick={this.handleCorporateSearchClick} />:''}

                 


                    {/* <FormGroup className="text-right">
                    <Button color="primary" type="submit" id="caseSubmit">Submit</Button>
                </FormGroup> */}

                </Form>
                <Modal show={this.state.showModal} className='Large-Modal' modalClosed={this.handleModal} >

                    {search}
                    {this.state.body}
                </Modal>
            </CardBody>)
    }
}

// export default BulkCaseForm;

const renderField = ({ className, input, label, type, placeholder, onclick,
    meta: { touched, error, warning } }) => {

    return (

        <FormGroup>
            <Label>{label}&nbsp;<span className="text-danger">*</span></Label>
            <Row>
                <Col>
                    <input {...input} onClick={onclick} placeholder={placeholder} type={type} className={className} required readOnly="true" />
                    {touched && ((error && <span className="error text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
                </Col>
            </Row>
        </FormGroup>

    )
}
const required = value => value ? null : 'Required';
const mapStateToProps = (state, ownProps) => ({
    selectedCorp: state.createCase.selectedCorporate,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    setSearchCorporateParameter: (param, search) => { dispatch(setSearchCorporateParameter(param, search)); },
    corporateResults: () => { dispatch(searchCorporateResultsSuccess()) },
    preloading : (data) => {dispatch(preloading(data))}
});
export default reduxForm({
    form: 'BulkCaseForm'
})(connect(mapStateToProps, mapDispatchToProps)(BulkCaseForm))